import axios from 'axios'
import util from '@/utils/util'
import constApp from '@/const/constApp'
import constKey from '@/const/constKey'
import { Message, MessageBox } from 'element-ui'

// 创建一个错误
function errorCreate(msg) {
  const err = new Error(msg)
  errorLog(err)
}

// 记录和显示错误
function errorLog(err) {
  // 显示提示
  Message({
    message: err.message,
    type: 'error',
    showClose: true,
    center: true,
    duration: 4 * 1000,
    // 信息显示偏移量top
    offset: 200
  })

  // 打印到控制台
  if (process.env.NODE_ENV === 'development') {
    util.log.danger('>>>>>> Error >>>>>>')
    console.log(err)
  }
}

// 创建一个axios实例
const service = axios.create({
  // api的base_url
  baseURL: process.env.VUE_APP_BASE_API,
  // request timeout
  timeout: process.env.VUE_APP_AXIOS_TIMEOUT === undefined ? 60000 : process.env.VUE_APP_AXIOS_TIMEOUT,
  // 使用简单请求,复杂请求(多一次OPTIONS请求)可用 application/json
  headers: { 'Content-Type': 'text/plain; charset=utf-8' },
  // 由客户端来控制跨站点访问
  withCredentials: true
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在请求发送之前做一些处理
    setDefaultParams(config)
    // refreshToken(config)
    return config
  }, err => {
    // 发送失败
    errorLog(err)
    return Promise.resolve(err)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // dataAxios 是 axios 返回数据中的 data
    const dataAxios = response.data
    console.log('rspData', dataAxios)
    const { sure } = dataAxios // response.data.status

    if (sure === 'Y' || response.config.responseType === 'blob') {
      return dataAxios
    } else {
      sure === 'A' ? reAuthorize() : errorCreate(dataAxios.info)
      return Promise.reject(dataAxios.info ? dataAxios.info : response)
    }
  },
  error => {
    if (error.response) {
      error.message = error.response.data.info
      console.log('error.response', error.response)
      if (error.response.status === 401) {
        reAuthorize()
      } else if (error.response.status === 500) {
        error.message = '网络链接异常,请检查网络!'
      }
    }

    errorLog(error)
    return Promise.reject(error.response ? error.response.data : error)
  }
)

// 刷新令牌
function refreshToken(config) {
  // const token = util.cookies.get('token')
  // if (!token || token === 'undefined') {
  //   return
  // }

  // 以下接口不需要刷新令牌
  const whiteList = [
    constApp.serviceCode.defSERVICE, constApp.serviceCode.factSERVICE
  ]
  if (whiteList.indexOf(config.params[constKey.KEY_PARAMS.serviceID]) >= 0) {
    return
  }

  let userInfo = store.state.hstore.user.info
  const nowTime = new Date()
  var nowMill = nowTime.getTime()
  // console.log('nowMill', nowMill, userInfo.TKEN_OK)
  if ((nowMill > (userInfo.TKEN_OK - 600000)) && nowMill < userInfo.TKEN_OK) {
    // console.log('in exprie')
    service({
      method: 'post',
      url: '/v1/token/',
      params: {
        sID: constApp.serviceCode.defSERVICE,
        tID: 'FH0003'
      },
      data: {
        refresh: '0'
      }
    })
      .then(res => {
        userInfo.TKEN_OK = res.data.TKEN_OK
        // store.dispatch('hstore/user/set', userInfo, { root: true }).then(() => {})
      })
      .catch(err => {
        errorLog(err)
      })
  }
}

// 重新授权确认
function reAuthorize() {
  MessageBox.confirm('您的授权已过期或在其他地方登录，是否重新登录？', '授权过期', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  })
    .then(() => {
      util.cookies.remove('token')
      util.cookies.remove('uuid')
      location.reload()
    })
    .catch(() => {
    })
}

// 添加默认参数及签名
function setDefaultParams(config) {
  if (!config.data) {
    config.data = {}
  }
  config.data['aID'] = process.env.VUE_APP_IDNO
  config.data['cID'] = process.env.VUE_APP_CHANNEL
  // const token = util.cookies.get('token')
  // if (token && token !== 'undefined') {
  //   config.data['tKN'] = token
  // }

  if (util.cookies.get('schk')) {
    config.data['sCK'] = util.getSign(Object.assign(config.data, config.params))
  }
}

export default service
